import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import "../modal/modal.scss";
import Loader from "../Loader/Loader";

export default function DynamicDialog(props) {
  const {
    openModal,
    closeModel,
    title,
    content,
    actions,
    hasCustomCancelButton = false,
  } = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);

  const handleClose = () => {
    setOpen(false);
    closeModel();
  };

  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {!hasCustomCancelButton && (
            <Button
              style={{
                fontFamily: "Hind Siliguri",
                fontSize: "12px",
                fontWeight: "bold",
                marginRight: "5px",
              }}
              onClick={handleClose}
            >
              Cancel
            </Button>
          )}
          {actions}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
